import pages, { pagesConfig } from '../../config/pages';
import useToolsNavigation from '../../hooks/useToolsNavigation';
import useSessionStore from '../../../hooks/useSessionStore';

const useAdminSideBarConfig = () => {
  const { navigateTo } = useToolsNavigation();
  const sessionStore = useSessionStore();

  let entries = [
    // CRX menu items
    {
      pageId: pages.CRX_COACH_ONBOARDING,
      icon: pagesConfig[pages.CRX_COACH_ONBOARDING].icon,
      onClick: () => navigateTo(pagesConfig[pages.CRX_COACH_ONBOARDING].path),
      title: pagesConfig[pages.CRX_COACH_ONBOARDING].title,
    },
    {
      pageId: pages.ANALYTICS,
      icon: pagesConfig[pages.ANALYTICS].icon,
      onClick: () => navigateTo(pagesConfig[pages.ANALYTICS].path),
      title: pagesConfig[pages.ANALYTICS].title,
    },
    {
      pageId: pages.MY_COMMISSIONS,
      icon: pagesConfig[pages.MY_COMMISSIONS].icon,
      onClick: () => navigateTo(pagesConfig[pages.MY_COMMISSIONS].path),
      title: pagesConfig[pages.MY_COMMISSIONS].title,
    },
    {
      pageId: pages.FORMS,
      icon: pagesConfig[pages.FORMS].icon,
      onClick: () => navigateTo(pagesConfig[pages.FORMS].path),
      title: pagesConfig[pages.FORMS].title,
    },
    {
      pageId: pages.CRX_COACH_CONFIGS,
      icon: pagesConfig[pages.CRX_COACH_CONFIGS].icon,
      onClick: () => navigateTo(pagesConfig[pages.CRX_COACH_CONFIGS].path),
      title: pagesConfig[pages.CRX_COACH_CONFIGS].title,
    },
    // AC menu items
    {
      pageId: pages.AC_DASHBOARD,
      icon: pagesConfig[pages.AC_DASHBOARD].icon,
      onClick: () => navigateTo(pagesConfig[pages.AC_DASHBOARD].path),
      title: pagesConfig[pages.AC_DASHBOARD].title,
    },
    {
      pageId: pages.DATA_MIGRATION,
      icon: pagesConfig[pages.DATA_MIGRATION].icon,
      onClick: () => navigateTo(pagesConfig[pages.DATA_MIGRATION].path),
      title: pagesConfig[pages.DATA_MIGRATION].title,
    },
    {
      pageId: pages.AC_LEAD_DASHBOARD,
      icon: pagesConfig[pages.AC_LEAD_DASHBOARD].icon,
      onClick: () => navigateTo(pagesConfig[pages.AC_LEAD_DASHBOARD].path),
      title: pagesConfig[pages.AC_LEAD_DASHBOARD].title,
    },
    {
      pageId: pages.COACH_TASK_ADMIN,
      icon: pagesConfig[pages.COACH_TASK_ADMIN].icon,
      onClick: () => navigateTo(pagesConfig[pages.COACH_TASK_ADMIN].path),
      title: pagesConfig[pages.COACH_TASK_ADMIN].title,
    },
    {
      pageId: pages.AI_COACH_PROFILE,
      icon: pagesConfig[pages.AI_COACH_PROFILE].icon,
      onClick: () => navigateTo(pagesConfig[pages.AI_COACH_PROFILE].path),
      title: pagesConfig[pages.AI_COACH_PROFILE].title,
    },
    {
      pageId: pages.AI_COACH_INSTAGRAM_IDENTITY,
      icon: pagesConfig[pages.AI_COACH_INSTAGRAM_IDENTITY].icon,
      onClick: () => navigateTo(pagesConfig[pages.AI_COACH_INSTAGRAM_IDENTITY].path),
      title: pagesConfig[pages.AI_COACH_INSTAGRAM_IDENTITY].title,
    },
    // IS menu items
    {
      pageId: pages.INSIDE_SALES_DASHBOARD,
      icon: pagesConfig[pages.INSIDE_SALES_DASHBOARD].icon,
      onClick: () => navigateTo(pagesConfig[pages.INSIDE_SALES_DASHBOARD].path),
      title: pagesConfig[pages.INSIDE_SALES_DASHBOARD].title,
    },
    {
      pageId: pages.INSIDE_SALES_LEADS,
      icon: pagesConfig[pages.INSIDE_SALES_LEADS].icon,
      onClick: () => navigateTo(pagesConfig[pages.INSIDE_SALES_LEADS].path),
      title: pagesConfig[pages.INSIDE_SALES_LEADS].title,
    },
    {
      pageId: pages.INSIDE_SALES,
      icon: pagesConfig[pages.INSIDE_SALES].icon,
      onClick: () => navigateTo(pagesConfig[pages.INSIDE_SALES].path),
      title: pagesConfig[pages.INSIDE_SALES].title,
    },
    {
      pageId: pages.INSIDE_SALES_COMMISSIONS,
      icon: pagesConfig[pages.INSIDE_SALES_COMMISSIONS].icon,
      onClick: () => navigateTo(pagesConfig[pages.INSIDE_SALES_COMMISSIONS].path),
      title: pagesConfig[pages.INSIDE_SALES_COMMISSIONS].title,
    },
    {
      pageId: pages.INSIDE_SALES_CONTRACTS_MANAGER,
      icon: pagesConfig[pages.INSIDE_SALES_CONTRACTS_MANAGER].icon,
      onClick: () => navigateTo(pagesConfig[pages.INSIDE_SALES_CONTRACTS_MANAGER].path),
      title: pagesConfig[pages.INSIDE_SALES_CONTRACTS_MANAGER].title,
    },
    {
      pageId: pages.IS_AVAILABILITY,
      icon: pagesConfig[pages.IS_AVAILABILITY].icon,
      onClick: () => navigateTo(pagesConfig[pages.IS_AVAILABILITY].path),
      title: pagesConfig[pages.IS_AVAILABILITY].title,
    },
    {
      pageId: pages.COMMISSIONS,
      icon: pagesConfig[pages.COMMISSIONS].icon,
      onClick: () => navigateTo(pagesConfig[pages.COMMISSIONS].path),
      title: pagesConfig[pages.COMMISSIONS].title,
    },
    {
      pageId: pages.INTERNAL_USERS,
      icon: pagesConfig[pages.INTERNAL_USERS].icon,
      onClick: () => navigateTo(pagesConfig[pages.INTERNAL_USERS].path),
      title: pagesConfig[pages.INTERNAL_USERS].title,
    },
    {
      pageId: pages.IS_COACH_CONFIGS,
      icon: pagesConfig[pages.IS_COACH_CONFIGS].icon,
      onClick: () => navigateTo(pagesConfig[pages.IS_COACH_CONFIGS].path),
      title: pagesConfig[pages.IS_COACH_CONFIGS].title,
    },
    // Support menu items
    {
      pageId: pages.RECIPES,
      icon: pagesConfig[pages.RECIPES].icon,
      onClick: () => navigateTo(pagesConfig[pages.RECIPES].path),
      title: pagesConfig[pages.RECIPES].title,
    },
    {
      pageId: pages.RECIPE_EDITOR,
      icon: pagesConfig[pages.RECIPE_EDITOR].icon,
      onClick: () => navigateTo(pagesConfig[pages.RECIPE_EDITOR].path),
      title: pagesConfig[pages.RECIPE_EDITOR].title,
    },
    {
      pageId: pages.REUSABLE_CONTRACTS,
      icon: pagesConfig[pages.REUSABLE_CONTRACTS].icon,
      onClick: () => navigateTo(pagesConfig[pages.REUSABLE_CONTRACTS].path),
      title: pagesConfig[pages.REUSABLE_CONTRACTS].title,
    },
    {
      pageId: pages.INTERNAL_ASSIGNMENTS,
      icon: pagesConfig[pages.INTERNAL_ASSIGNMENTS].icon,
      onClick: () => navigateTo(pagesConfig[pages.INTERNAL_ASSIGNMENTS].path),
      title: pagesConfig[pages.INTERNAL_ASSIGNMENTS].title,
    },
    {
      pageId: pages.COACH_VOICE,
      icon: pagesConfig[pages.COACH_VOICE].icon,
      onClick: () => navigateTo(pagesConfig[pages.COACH_VOICE].path),
      title: pagesConfig[pages.COACH_VOICE].title,
    },
    {
      pageId: pages.DISPUTES,
      icon: pagesConfig[pages.DISPUTES].icon,
      onClick: () => navigateTo(pagesConfig[pages.DISPUTES].path),
      title: pagesConfig[pages.DISPUTES].title,
    },
    // Only for super users
    {
      pageId: pages.USER_MANAGEMENT,
      icon: pagesConfig[pages.USER_MANAGEMENT].icon,
      onClick: () => navigateTo(pagesConfig[pages.USER_MANAGEMENT].path),
      title: pagesConfig[pages.USER_MANAGEMENT].title,
    },
    {
      pageId: pages.POD_SETTINGS,
      icon: pagesConfig[pages.POD_SETTINGS].icon,
      onClick: () => navigateTo(pagesConfig[pages.POD_SETTINGS].path),
      title: pagesConfig[pages.POD_SETTINGS].title,
    },
    {
      pageId: pages.CHECK_IN_THEMES,
      icon: pagesConfig[pages.CHECK_IN_THEMES].icon,
      onClick: () => navigateTo(pagesConfig[pages.CHECK_IN_THEMES].path),
      title: pagesConfig[pages.CHECK_IN_THEMES].title,
    },
    {
      pageId: pages.SMART_CONTEXT_ANALYTICS,
      icon: pagesConfig[pages.SMART_CONTEXT_ANALYTICS].icon,
      onClick: () => navigateTo(pagesConfig[pages.SMART_CONTEXT_ANALYTICS].path),
      title: pagesConfig[pages.SMART_CONTEXT_ANALYTICS].title,
    },
    {
      pageId: pages.RELEASE_NOTES,
      icon: pagesConfig[pages.RELEASE_NOTES].icon,
      onClick: () => navigateTo(pagesConfig[pages.RELEASE_NOTES].path),
      title: pagesConfig[pages.RELEASE_NOTES].title,
    },
    // SDR menu items
    {
      pageId: pages.SDR_LEAD_INBOX,
      icon: pagesConfig[pages.SDR_LEAD_INBOX].icon,
      onClick: () => navigateTo(pagesConfig[pages.SDR_LEAD_INBOX].path),
      title: pagesConfig[pages.SDR_LEAD_INBOX].title,
    },
    {
      pageId: pages.MASS_TEXT_OUTREACH,
      icon: pagesConfig[pages.MASS_TEXT_OUTREACH].icon,
      onClick: () => navigateTo(pagesConfig[pages.MASS_TEXT_OUTREACH].path),
      title: pagesConfig[pages.MASS_TEXT_OUTREACH].title,
    },
    // Marketing menu items
    {
      pageId: pages.WEBFLOW_DEPLOYER,
      icon: pagesConfig[pages.WEBFLOW_DEPLOYER].icon,
      onClick: () => navigateTo(pagesConfig[pages.WEBFLOW_DEPLOYER].path),
      title: pagesConfig[pages.WEBFLOW_DEPLOYER].title,
    },
  ];

  entries = entries.filter((entry) => {
    const permissions = sessionStore.getPagePermissions(entry.pageId);
    return permissions && permissions.includes('EDIT');
  });

  return {
    entries,
  };
};

export default useAdminSideBarConfig;
